import Resource from '@/api/resource'
import request from '@/utils/request'
import store from '@/store/index'

class Versions extends Resource {
  constructor() {
    super('versions')
  }

  list(query) {
    return request({
      url: `${this.uri}/index`,
      method: 'POST',
      data: query,
    })
  }

  remove(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
    })
  }

  put(query) {
    return request({
      url: `/${this.uri}/store`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query,
      // onUploadProgress: function (progressEvent) {
      //     store.commit('app/SET_UPLOAD_PROGRESS', parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
      // }.bind(store),
    })
  }

  update(query) {
    return request({
      url: `/${this.uri}/update/${query.id}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query.query,
      //   onUploadProgress: function (progressEvent) {
      //     store.commit('app/SET_UPLOAD_PROGRESS', parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
      //   }.bind(store),
    })
  }

  get(id) {
    return request({
      url: `/${this.uri}/show/${id}`,
      method: 'get',
    })
  }

  statusLookups() {
    return request({
      url: `/${this.uri}/statusLookups`,
      method: 'get',
    })
  }
}

export { Versions as default }
